module.exports = __webpack_public_path__ + "img/24-1.c85faf49.png";